import {GetObligationHistory} from 'domain/usecases';
import {RemoteGetObligationHistory} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetObligationHistory = (): GetObligationHistory =>
	new RemoteGetObligationHistory(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.paymentsHistory),
		makeAuthorizeHttpClientDecorator(),
	);
